module.exports = __webpack_public_path__ + "static/media/rinascente-icon.ebcd88f4.svg";